var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"generic-blocks-container"},_vm._l((_vm.structure),function(item,index){return _c('block',{key:index,attrs:{"block":item,"data":_vm.data}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }